import { FC, useRef } from "react";
import { pricingData, solutionsData } from "./constant";
import { Link } from "react-router-dom";
import { useClickOutSideComponent } from "helpers/screenHelpers";
import { NavigationLink } from "./NavigationLink";

interface Props {
  onClose: () => void;
  triggerRef: React.RefObject<HTMLButtonElement>;
}

export const PricingModal: FC<Props> = ({ onClose, triggerRef }) => {
  const optionsRef = useRef<HTMLDivElement>(null);

  useClickOutSideComponent([optionsRef, triggerRef], onClose);

  return (
    <div ref={optionsRef}>
      <div className="hidden md:flex flex-col gap-4 absolute -right-full mt-2 bg-white w-[180px] cursor-pointer p-4 shadow-md border border-[#E5EAF0] rounded-xl">
        {pricingData.map((price) => (
          <Link
            key={price.path}
            to={price.path}
            className="flex items-center gap-3"
            onClick={onClose}
          >
            {price.name}
          </Link>
        ))}
      </div>

      <div className="md:hidden flex flex-col gap-8">
        {pricingData.map((pricing) => (
          <NavigationLink
            to={pricing.path}
            label={pricing.name}
            key={pricing.name}
            onClose={onClose}
          />
        ))}
      </div>
    </div>
  );
};
